<template>
  <div class="kt-portlet__body">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TabbedPortletBody'
}
</script>

<style lang="scss" scoped>
.kt-portlet .kt-portlet__body {
  min-height: 490px !important;
}
</style>
